import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import Acknowledgment from './Acknowledgment';

const EditNumber = ({ numberToEdit, onClose, onUpdate }) => {
  const [phnoCampaign, setPhnoCampaign] = useState('');
  const [phnoDescription, setPhnoDescription] = useState('');
  const [showForwardInput, setShowForwardInput] = useState(false);
  const [forwardNumber, setForwardNumber] = useState('');
  const [source, setSource] = useState('');
  const [showSourceInput, setShowSourceInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showAcknowledgment, setShowAcknowledgment] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const updatePhone = process.env.REACT_APP_updatePhone;
  const [isEditNumberVisible, setIsEditNumberVisible] = useState(true);
  const [acknowledgment, setAcknowledgment] = useState(null);

  useEffect(() => {
    if (numberToEdit) {
      setPhnoCampaign(numberToEdit.phno_campaign || '');
      setPhnoDescription(numberToEdit.phno_description || '');
      setShowForwardInput(!!numberToEdit.forward_phone_number);
      setForwardNumber(numberToEdit.forward_phone_number || '');
      setShowSourceInput(!!numberToEdit.source);
      setSource(numberToEdit.source || '');
    }
  }, [numberToEdit]);

  // console.log(numberToEdit);  
  // console.log(numberToEdit.forward_enabled);

  //   const handleUpdate = (updatedNumber) => {
  //   setNumbers(numbers =>
  //     numbers.map(num => num.pk === updatedNumber.pk ? updatedNumber : num)
  //   );
  // };

  const handleSubmit = async () => {
    if (showForwardInput) {
      if (!/^\d{10}$/.test(forwardNumber)) {
        setAcknowledgment({
          status: 'warning',
          message: 'Forward number must be exactly 10 digits.',
        });
        return; // Stop form submission
      }
    }

  
    const forwardEnabled = showForwardInput && /^\d{10}$/.test(forwardNumber);

    if (!phnoCampaign || phnoCampaign.trim() === '') {
      setAcknowledgment({
        status: 'warning',
        message: 'Campaign name cannot be empty',
      });
      return;
    }
    setIsLoading(true);

    const payload = {
      pk: numberToEdit.pk,
      phno_campaign: phnoCampaign,
      phno_description: phnoDescription,
      ...(forwardEnabled && { forward_number: forwardNumber }),
      ...(showSourceInput && { source: source }),
    };
    console.log("payload.....", payload);


    try {
      const session = await Auth.currentSession();
      const token = session.getIdToken().getJwtToken();

      const response = await fetch(updatePhone, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      setIsLoading(false);
      console.log("Data......", data);

      setAcknowledgment({
        status: response.status === 200 ? 'success' : 'warning',
        message: data.message,
      });

      if (response.status === 200) {
        if (onUpdate) {
          onUpdate({
            ...numberToEdit,
            phno_campaign: phnoCampaign,
            phno_description: phnoDescription,
            forward_phone_number: showForwardInput ? forwardNumber : '',
            source: showSourceInput ? source : '',
          });
        }
        setIsEditNumberVisible(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      setAcknowledgment({ status: 'warning', message: error.message });
    }
  };

  const handleAcknowledgmentClose = () => {
    setAcknowledgment(null);
    setTimeout(() => {
      window.location.reload();
    }, 18000);
  };

  return (
    <>
      {isEditNumberVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded shadow p-8 w-96">
            <h2 className="text-lg font-bold mb-6">Edit</h2>
            <form>
              <div className="mb-4">
                <label htmlFor="phnoCampaign" className="block text-sm font-medium text-gray-700">
                  Campaign Name
                </label>
                <input
                  type="text"
                  id="phnoCampaign"
                  className="mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  value={phnoCampaign}
                  onChange={(e) => setPhnoCampaign(e.target.value)}
                // readOnly
                // onFocus={() => setShowWarning(true)} 
                // onBlur={() => setShowWarning(false)} 
                />
                {/* {showWarning && (
              <p className="text-xs text-red-600 mt-1">* The campaign name cannot be changed once created.</p>
            )} */}
              </div>
              <div className="mb-4">
                <label htmlFor="phnoDescription" className="block text-sm font-medium text-gray-700">
                  Description
                </label>
                <textarea
                  id="phnoDescription"
                  className="mt-1 block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  rows="3"
                  value={phnoDescription}
                  onChange={(e) => setPhnoDescription(e.target.value)}
                ></textarea>
              </div>

              {/* Forward Number Input */}
              <div className="mb-4 flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setShowForwardInput((prev) => !prev)}
                  className={`w-8 h-4 flex items-center rounded-full  duration-300 ease-in-out
                    ${showForwardInput ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                  <div
                    className={`bg-white w-3 h-3 rounded-full shadow-md transform duration-300 ease-in-out
                      ${showForwardInput ? 'translate-x-5' : 'translate-x-0'}`}
                  />
                </button>
                <span className="text-sm text-gray-700">Enable Forward Number</span>
              </div>
              {showForwardInput && (
                <div className="mb-4">
                  <label htmlFor="forwardNumber" className="block text-sm font-medium text-gray-700">
                    Phone Number
                  </label>
                  <div className="flex items-center mt-1">
                    <span className="px-3 py-2 border border-gray-300 bg-gray-100 rounded-l-md text-sm text-gray-700">+1</span>
                    <input
                      type="text"
                      id="forwardNumber"
                      name="forwardNumber"
                      maxLength={10}
                      // pattern="\d{10}"
                      className="block w-full py-2 px-3 border border-gray-300 rounded-r-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Enter 10-digit number"
                      value={forwardNumber}
                      onChange={(e) => setForwardNumber(e.target.value)}
                    />
                  </div>
                </div>
              )}

              {/* Source Input */}
              <div className="mb-2  flex items-center gap-2">
                <button
                  type="button"
                  onClick={() => setShowSourceInput((prev) => !prev)}
                  className={`w-8 h-4 flex items-center rounded-full  duration-300 ease-in-out
                    ${showSourceInput ? 'bg-green-500' : 'bg-gray-300'}`}
                >
                  <div
                    className={`bg-white w-3 h-3 rounded-full shadow-md transform duration-300 ease-in-out
                      ${showSourceInput ? 'translate-x-5' : 'translate-x-0'}`}
                  />
                </button>
                <span className="text-sm text-gray-700">Enable Alternate Source</span>
              </div>
              {showSourceInput && (
                <div className="mb-2 ">
                  <label htmlFor="source" className="block text-sm font-medium text-gray-700">
                    Source
                  </label>
                  <div className="flex items-center mt-1 mr-2">
                    <input
                      type="text"
                      id="source"
                      name="source"
                      // maxLength={10}
                      // pattern="\d{10}"
                      className="block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Enter source"
                      value={source}
                      onChange={(e) => setSource(e.target.value)}
                    />
                  </div>
                </div>
              )}

              <div className="flex justify-end">
                <button
                  type="button"
                  className="mr-2 py-2 px-4 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none focus:bg-red-600"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="py-2 px-4 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
                  onClick={handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? 'Updating...' : 'Update'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {acknowledgment && (
        <Acknowledgment acknowledgment={acknowledgment} onClose={handleAcknowledgmentClose} />
      )}
    </>
  );
};

export default EditNumber;